import type { FC } from 'react';
import { useCallback } from 'react';

import {
  useBlockSelector,
  useBuyStoreRawItemMutation,
  useStoreItemQuery,
  bundles as bundlesHelper,
} from '@site-builder/block-helpers';
import { useQueryClient } from '@tanstack/react-query';

import { StoreCardWrapper, ComposerClub } from './components';

const App: FC = () => {
  const composerClub = useBlockSelector((b) => b?.composerClub);
  const queryClient = useQueryClient();

  const qStoreItem = useStoreItemQuery(composerClub);

  const qBundle = bundlesHelper.useFiniteQuery();

  const composerClubBundle = qBundle.data?.find((el) => {
    if (qStoreItem.data?.sku) {
      return el.sku === qStoreItem.data.sku;
    }
    if (qStoreItem.isError) {
      return el.name === 'Composer Club' || el.sku === 'composer-club';
    }
    return false;
  });

  const buyMutation = useBuyStoreRawItemMutation();

  const handlePurchase = useCallback((): void => {
    if (!composerClubBundle) return;
    buyMutation.mutate(composerClubBundle, {
      onSuccess: async () => {
        await queryClient.refetchQueries({
          queryKey: ['store-item'],
          type: 'active',
        });
        qBundle.refetch();
      },
    });
  }, [buyMutation, queryClient, qBundle, composerClubBundle]);

  if (
    !composerClub ||
    qBundle.isError ||
    qBundle.isPending ||
    !composerClubBundle
  ) {
    return null;
  }

  return (
    <>
      <StoreCardWrapper item={composerClubBundle} onPurchase={handlePurchase}>
        <ComposerClub data={composerClubBundle} />
      </StoreCardWrapper>
    </>
  );
};

export default App;
